<template>
  <section class="commission">
    <h4>{{ name }}</h4>
    <div>{{ commissionToDisplay }}</div>
  </section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import type { Commission } from './CommissionDetails.vue';

const props = defineProps<{
  name: string,
  commissionList: Commission[],
}>();

const name = computed(() => props.commissionList[0].name);

const commissionToDisplay = computed(() => {
  const commissions = [];

  for (const commissionItem of props.commissionList) {
    commissions.push(`${commissionItem.amount} ${commissionItem.currency}`);
  }

  return commissions.join(' + ');
});
</script>

<style lang="scss" scoped>
@import "@scss-vars";

.commission {
  display: grid;
  grid-gap: 4px;
  text-align: center;
  color: $black;
}
</style>